module.exports = "/_next/static/images/technologiesUse-be7c0d563f7beef1f1e4492120f0c569.jpg.webp";